import { defineComponent as r, createBlock as s, openBlock as p, unref as t, withCtx as c, createElementVNode as i, normalizeClass as a, createVNode as m, toDisplayString as u } from "vue";
import { ListboxOption as d } from "@headlessui/vue";
import { cva as b, cx as f } from "@scalar/use-hooks/useBindCx";
import v from "./ScalarListboxCheckbox.vue.js";
const w = /* @__PURE__ */ r({
  __name: "ScalarListboxItem",
  props: {
    option: {},
    multiselect: { type: Boolean }
  },
  setup(g) {
    const n = b({
      base: [
        // Layout
        "group/item",
        "flex min-w-0 items-center gap-1.5 rounded px-2 py-1.5 text-left",
        // Text / background style
        "truncate bg-transparent text-c-1",
        // Interaction
        "cursor-pointer hover:bg-b-2"
      ],
      variants: {
        selected: { true: "text-c-1" },
        active: { true: "bg-b-2" },
        disabled: { true: "pointer-events-none opacity-50" }
      }
    });
    return (e, x) => (p(), s(t(d), {
      as: "template",
      disabled: e.option.disabled,
      value: e.option
    }, {
      default: c(({ active: l, selected: o }) => [
        i("li", {
          class: a(t(f)(t(n)({ active: l, selected: o, disabled: e.option.disabled })))
        }, [
          m(v, {
            selected: o,
            multiselect: e.multiselect
          }, null, 8, ["selected", "multiselect"]),
          i("span", {
            class: a(["inline-block min-w-0 flex-1 truncate", e.option.color ? e.option.color : "text-c-1"])
          }, u(e.option.label), 3)
        ], 2)
      ]),
      _: 1
    }, 8, ["disabled", "value"]));
  }
});
export {
  w as default
};
